import React from "react";
import { Container, Row, Col, Carousel, Button, Card } from "react-bootstrap";
import '../../../Assets/css/movadoWatch.css'
import BannerImgDesktop from '../../../Assets/images/watches/movado-imgs/banner-desktop.png'
import BannerImgMobile from '../../../Assets/images/watches/movado-imgs/banner-mobile.png'
import Bannerbottom from '../../../Assets/images/watches/movado-imgs/banner-bottom.png'
import { isMobile, isMobileOnly } from "react-device-detect";
import NewArrivals1 from '../../../Assets/images/watches/movado-imgs/new-arrivals/n1.png'
import NewArrivals2 from '../../../Assets/images/watches/movado-imgs/new-arrivals/n2.png'
import NewArrivals3 from '../../../Assets/images/watches/movado-imgs/new-arrivals/n3.png'
import NewArrivals4 from '../../../Assets/images/watches/movado-imgs/new-arrivals/n4.png'
import NewArrivals5 from '../../../Assets/images/watches/movado-imgs/new-arrivals/n5.png'
import NewArrivals6 from '../../../Assets/images/watches/movado-imgs/new-arrivals/n6.png'
import NewArrivals7 from '../../../Assets/images/watches/movado-imgs/new-arrivals/n7.png'
import NewArrivals8 from '../../../Assets/images/watches/movado-imgs/new-arrivals/n8.png'

import bestSeller from '../../../Assets/images/watches/movado-imgs/best-seller-img.png'
import boldFusion from '../../../Assets/images/watches/movado-imgs/bold-fusion.png'

import Slider from "react-slick";
import {Link} from 'react-router-dom'
const MovadoPage = () => {

    const settingsNewArrivals = {
        dots: false,
        infinite: false,
        autoplay: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        initialSlide: 0,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true,
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    initialSlide: 2,
                    autoplay: true,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    initialSlide: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            }
        ]
    };

  return (
    <div className='movadoWatch_section'>
               {/* banner Image */}
               <Container fluid>
                   <Row>
                       <Col sm={12} md={12} lg={12} className="p-0">
                           <div>
                               {isMobileOnly ? <img src={BannerImgMobile} alt="Lifestyle" className="w-100" /> : <img src={BannerImgDesktop} alt="Lifestyle" className="w-100" />}
                           </div>
                       </Col>
                   </Row>
               </Container>
               {/* New Arrivals */}
               <Container fluid className=" my-md-4 my-3 my-lg-5 text-center">
                   <Row>
                       <Col sm={12} md={12} lg={12}>
                           <div>
                               <h3 className="mb-4">New Arrivals</h3>
                           </div>
                       </Col>
                   </Row>
                   <Row>
                       <Col sm={12} md={12} lg={12}>
                           <Slider {...settingsNewArrivals}>
                               {[
                                   { id: 1, img: NewArrivals1, title: "Luxury Steel" },
                                   { id: 2, img: NewArrivals2, title: "Classic Gold" },
                                   { id: 3, img: NewArrivals3, title: "Premium Style" },
                                   { id: 4, img: NewArrivals4, title: "Silver Touch" },
                               ].map((item) => (
                                   <div className="mo_settingsNewArrivals_outer_box">
                                       <Card className="border-0">
                                           <Card.Img variant="top" src={item.img} />
                                           <Card.Body>
                                               <Link to="/watches-list/Movado" className="mo_btn_explore">Explore Now</Link>
                                           </Card.Body>
                                       </Card>
                                   </div>
                               ))}
   
                           </Slider>
                       </Col>
                   </Row>
               </Container>
   
               {/* Best Sellers Section */}
               <Container fluid className="my-md-4 my-3 my-lg-5">
                   <Row>
                       <Col sm={12} md={12} lg={12}>
                           <div className="position-relative text-center">
                               <img src={bestSeller} alt="Best Sellers" className="w-100 margin_b" />
                               <div className="mo_banner_text_box box1 top-50 start-50 translate-middle text-white">
                                   <h2>Best Sellers</h2>
                                   <p>from modern icons archival inspired</p>
                                   <Link to="/watches-list/Movado" className="mo_btn_explore_white">Shop Now</Link>
                               </div>
                           </div>
                       </Col>
                   </Row>
               </Container>
   
               {/* Bold Fusion Section */}
               <Container fluid className="my-md-4 my-3 my-lg-5 text-white">
                   <Row className="align-items-center">
                       <Col>
                           <div className="position-relative text-left">
                               <img src={boldFusion} alt="Best Sellers" className="w-100 margin_b" />
                               <div className="mo_banner_text_box  translate-middle text-white">
                                   <h2>Bold Fusion</h2>
                                   <p>
                                       A watch designed with elegance and strength. Perfect blend of modern
                                       design and luxury feel.
                                   </p>
                               </div>
                           </div>
                       </Col>
                   </Row>
               </Container>
   
               {/* Product Showcase */}
               <div style={{ backgroundColor: "#F9F9FA" }} className="py-3 py-md-4 py-lg-5">
                   <Container fluid className=" text-center">
                       <Row>
                           <Col sm={12} md={12} lg={12}>
                               <Slider {...settingsNewArrivals}>
                                   {[
                                       { id: 1, img: NewArrivals5, title: "Luxury Steel" },
                                       { id: 2, img: NewArrivals6, title: "Classic Gold" },
                                       { id: 3, img: NewArrivals7, title: "Premium Style" },
                                       { id: 4, img: NewArrivals8, title: "Silver Touch" },
                                   ].map((item) => (
                                       <div className="mo_settingsNewArrivals_outer_box">
                                           <Card className="border-0 bg-transparent">
                                               <Card.Img variant="top" src={item.img} />
                                               <Card.Body> 
                                                 <Link to="/watches-list/Movado" className="mo_btn_explore">Explore Now</Link>
                                               </Card.Body>
                                           </Card>
                                       </div>
                                   ))}
   
                               </Slider>
                           </Col>
                       </Row>
                   </Container>
               </div>
   
               {/* Lifestyle Image */}
               <Container fluid>
                   <Row>
                       <Col sm={12} md={12} lg={12} className="p-0">
                       <div>
                           <img src={Bannerbottom} alt="Lifestyle" className="w-100" />
                       </div>
                       </Col>
                   </Row>
               </Container>
           </div>
  )
}

export default MovadoPage
